import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { removeUserData } from "../axios/axios-config";

const useLogout = () => {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    removeUserData();
    navigate("/login", { replace: true });
  }, [navigate]);

  return { logout };
};

export default useLogout;
